module.exports = __webpack_public_path__ + "img/success.6021985a.svg";